export default __webpack_public_path__ + "static/media/rentabilidadIcon.a306171e.svg";